import React, {
  createContext,
  ReactNode,
  useContext,
  useLayoutEffect,
  useState,
} from 'react'

import { document } from '@emico/ssr-utils'

const PortalContext = createContext<HTMLDivElement | null>(null)

export const usePortalElement = () => {
  const [elem] = useState<HTMLDivElement | undefined>(
    document?.createElement('div'),
  )

  const portalTarget = useContext(PortalContext)
  // useLayoutEffect is necessary here so repaintOnMount works for child
  // components. I think this would otherwise delay the attaching to the DOM
  // which in turn makes the `elem.scrollTop` happen before the element is
  // mounted, which will break the transition.
  useLayoutEffect(() => {
    if (!portalTarget || !elem) {
      return
    }

    portalTarget.appendChild(elem)
    return () => {
      portalTarget.removeChild(elem)
    }
  }, [portalTarget, elem])

  return elem
}

interface Props {
  children: ReactNode
}

const PortalTarget = ({ children }: Props) => {
  const [portal, setPortal] = useState<HTMLDivElement | null>(null)

  return (
    <PortalContext.Provider value={portal}>
      {children}

      <div ref={setPortal} />
    </PortalContext.Provider>
  )
}

export default PortalTarget
